import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';
import { Component, OnInit } from '@angular/core';
import { NotifierService } from 'angular-notifier';
import { ExcelViewerService } from 'src/app/repository/service/excel-viewer.service';
import { RepoApiService } from 'src/app/repository/service/repo-api.service';
import { ReportService } from 'src/app/repository/service/report.service';

@Component({
  selector: 'app-kpi-reorder',
  templateUrl: './kpi-reorder.component.html',
  styleUrls: ['./kpi-reorder.component.scss']
})
export class KpiReorderComponent implements OnInit {
  // public kpiRows:any[] = [];
  // public kpiKey:string = ""
  // public selectedKpi:any = {};
  // public dragType:string="row";
  public kpiListLocal:any[] = [];
  public kpiListOriginal:any[] = [];
  constructor(
    private notifier:NotifierService,
    public evService:ExcelViewerService,
    private repoService:RepoApiService
    ) { }

  ngOnInit(): void {
    this.kpiListLocal = [];
    this.kpiListOriginal = [];
    let kpis = JSON.parse(JSON.stringify(this.evService.selectedSheet.value["kpis"]));
    this.evService.selectedSheetReorderedKpis = {}
    Object.keys(kpis).forEach((kpiKey) => {
      this.kpiListLocal.push({id :kpis[kpiKey].kpi_id, name: kpis[kpiKey].name, label: kpiKey, priority:kpis[kpiKey].kpi_id, isGroup: "rows" in kpis[kpiKey].options ? false : true, isOpenGroup:false, options:kpis[kpiKey].options});
      this.kpiListOriginal.push({id :kpis[kpiKey].kpi_id, name: kpis[kpiKey].name, label: kpiKey, priority:kpis[kpiKey].kpi_id})
    });
  }

  
  // onSubmit(){
  //   this.kpiListOriginal.forEach((kpi) => {
  //     kpi["priority"] = this.kpiListLocal.findIndex(rItem => rItem.id === kpi.id);
  //   });
  //   // console.log("this.kpiListLocal ===>",this.kpiListLocal)
  //   // console.log("this.kpiListOriginal ===>",this.kpiListOriginal);
  //   this.evService.isLoading = true;
  //   let body = {
  //     data : this.kpiListOriginal,
  //     sheet_id: this.evService.selectedSheet.value["sheet_id"]
  //   }
  //   // console.log("body ===>",body)
  //   // id:this.kpiListOriginal[0].id
  //   this.repoService.setKpiPriority(body).subscribe(
  //     result=>{
  //       if (result["status"] == 1) {
  //         this.notifier.notify("success","Table priority set successfully");
  //         this.evService.refreshFilterOptions();
  //         this.evService.isLoading = false;
  //         this.evService.closeKPIReorder();
  //       }else{
  //         this.notifier.notify("error",result["message"]);
  //         this.evService.isLoading = false;
  //       }
  //     }, error =>{
  //       console.log(error);
  //       this.evService.isLoading = false;
  //     }
  //   )
  // }

  onSubmit(){
    let body = {
      data : [],
      sheet_id: this.evService.selectedSheet.value["sheet_id"]
    }
    Object.keys(this.evService.selectedSheetReorderedKpis).forEach(kpiKey => {
      body.data.push(this.evService.selectedSheetReorderedKpis[kpiKey])
    });
    this.repoService.setKpiPriority(body).subscribe(
      result=>{
        if (result["status"] == 1) {
          this.notifier.notify("success","Table priority set successfully");
          this.evService.refreshFilterOptions();
          this.evService.isLoading = false;
          this.evService.closeKPIReorder();
        }else{
          this.notifier.notify("error",result["message"]);
          this.evService.isLoading = false;
        }
      }, error =>{
        console.log(error);
        this.evService.isLoading = false;
      }
    )
  }
  
  drop(event: CdkDragDrop<string[]>) {
    moveItemInArray(this.kpiListLocal, event.previousIndex, event.currentIndex);
    setTimeout(() => {
      this.kpiTreeRerderMap()
    }, 100);
  }

  openGroup(kpi){
    kpi.isOpenGroup = !kpi.isOpenGroup
  }

  kpiTreeRerderMap(){    
    this.kpiListOriginal.forEach((kpi) => {
      let index = <number> this.kpiListLocal.findIndex(rItem => rItem.id === kpi.id);
      kpi["priority"] = index + 1;
      this.evService.selectedSheetReorderedKpis[kpi["label"]] = kpi
    });
  }
}
